import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { noop } from 'lodash/fp';
import {
  precisionSelector,
  dataFormatSelector,
} from 'selectors/indicator';
import styles from './snapshotCallout.scss';

const SnapshotCallout = ({
  geography,
  value,
  year,
  label,
}) => (
  <dl className={styles.snapshotCallout}>
    <dt className={styles.label}>
      {label}
      <span className="screen-reader-text">
        of {geography} in {year}
      </span>
    </dt>
    <dt className={styles.geography} aria-hidden>{geography}, {year}</dt>
    <dd className={styles.value}>{value}</dd>
  </dl>
);

SnapshotCallout.propTypes = {
  geography: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  year: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  label: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  precision: precisionSelector(state),
  dataFormat: dataFormatSelector(state),
});

const mergeProps = (
  { precision, dataFormat },
  dispatchProps,
  { value, ...ownProps }
) => {
  const localeConfig = {
    style: dataFormat,
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  };
  if ('currency' === dataFormat) {
    localeConfig.currency = 'USD';
  }
  return {
    ...ownProps,
    value: parseFloat(value, 10).toLocaleString('en-US', localeConfig),
  };
};

export default connect(mapStateToProps, noop(), mergeProps)(SnapshotCallout);



// WEBPACK FOOTER //
// ./app/components/snapshotCallout/index.js